(($, Drupal, drupalSettings) => {
  Drupal.behaviors.availabletimes = {

    attach: (context, settings) => {
      // Find all elements which contains needed time to fetch
      var element = context.querySelectorAll('.fetch-times');
      if (element) {
        element.forEach( elem => {
          if (elem.classList.contains('uninitialized')) {
            new Drupal.getAvailabletimes( elem, settings['availabletimesapi'] );
          }
        });
      }
    },
  }

  Drupal.getAvailabletimes = function(el, settings) {
    this.initialize(el, settings);
  }

  Drupal.getAvailabletimes.prototype.initialize = function(el, settings) {
    this.el = el;
    this.api= settings;
    this.assisDent = new Drupal.assisDentCaller();
    this.assisDent.getPersonsAvailableTimes([this.el.dataset.useruuid], this.updateTimeElement.bind(this), true);

    el.classList.remove('uninitialized');
  }

  Drupal.getAvailabletimes.prototype.updateTimeElement = function( data ) {

    this.el.innerHTML = '';
    this.el.classList.add('initialized');
    var listLength = data[this.el.dataset.useruuid].length;

    if( listLength > 0 ){
      for( var i = 0; i < (listLength > 1 ? 1 : listLength ); i++){
          var div = document.createElement('div');

          div.innerHTML = this.assisDent.getFormattedTime(data[this.el.dataset.useruuid][i].StartTime);
        this.el.appendChild(div);
      }
      this.el.parentElement.style.display = "";
      var linkElement = this.el.parentElement.querySelector('a.make-an-appointment');
      if (linkElement) {
        data[this.el.dataset.useruuid][0].ReasonId = 'none';
        linkElement.href = this.assisDent.getUrlForAppoitment(data[this.el.dataset.useruuid][0]);
      }
    }
    else {
      this.el.parentElement.parentNode.removeChild(this.el.parentElement);
    }
  }

})(jQuery, Drupal, drupalSettings);
